import { autoinject } from 'aurelia-framework';
import { TabManager } from '../../mooring/tab-manager';
import { RouterConfiguration } from 'aurelia-router';
import { tabRoutes } from './invoice-spagetti-products-tab-routes';

@autoinject
export class WashView {
  constructor(private tabManager: TabManager) {}

  get tab() {
    return this.tabManager.currentTabIndex;
  }

  private configureRouter(config: RouterConfiguration) {
    config.map(tabRoutes);
  }
}
